var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-menu scroll-bar"},[_c('div',[_c('tree-menu',{attrs:{"children":_vm.routes}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }